import React, { useContext} from 'react';
import styled from 'styled-components/macro';
import Checkbox from '@material-ui/core/Checkbox';
import MinimalSelect from '../../ui/MinimalSelect';
import { Field, TextField, CheckboxField } from '../UI';
import EditorContext from '../../../modules/contexts/editor';

import deletePNG from '../../../assets/images/delete.png';

const BlockWrapper = styled.div`
`;

const LinkBlockWrapper = styled(Field)`
    display: table;
`;
const LinkBlockRow = styled.div`
    display: table-row;
    flex-direction: row;
`;
const LinkBlockField = styled.div`
    display: table-cell;
    max-width: min-content;
    position: relative;
`;
const Value = styled(TextField)`
    padding-right: 10px;
`;
const ColorSelect = styled(MinimalSelect)`
    width: 70px;
`;
const Underline = styled(Checkbox)`
    width: 11px;
    height: 0px;
    color: #9a9a9a !important;
`;
const Delete = styled.img`
    width: 24px;
    content: url(${deletePNG});
    align-self: center;
    cursor: pointer;
    position: absolute;
    bottom: 6px;
    left: -10px
`;
const AddBlock = styled.div`
    font-weight: bold;
    border: thin solid #ababab;
    border-radius: 50%;
    cursor: pointer;
    padding: 2px;
    margin: 8px 8px;
    width: 17px;
    height: 17px;
    text-align: center;
    font-size: 16px;
    background-color: #ffffff;
`;

export const LinkBlock = ({ node, field }) => {
    const editor = useContext(EditorContext);

    const subfieldChanged = (pn, i, subfield, value) => {
        editor.updateElementFieldPart(node, field, pn, i, subfield, value);
        editor.commitNodeUpdate(node);
    };

    const addRow = (e, pn) => {
        const newParts = [...field.parts[pn]];
        newParts.push({ label: '-label-', lessonDescriptor: '-descr-', target: 'false' });
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
    };

    const deleteRow = (e, pn, i, p) => {
        const newParts = [...field.parts[pn]];
        newParts.splice(i, 1);
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
    };

    return (
        <LinkBlockWrapper>
            <LinkBlockRow><LinkBlockField>Label</LinkBlockField><LinkBlockField>Lesson descr.</LinkBlockField><LinkBlockField>Target lesson</LinkBlockField></LinkBlockRow>
            { field.parts.links.map((p, i) =>
                <LinkBlockRow key={`${i}`}>
                    <LinkBlockField><Value inputRef={input => { if (input) input.value = p.label; }} onBlur={e => subfieldChanged('links', i, 'label', e.target.value)} /></LinkBlockField>
                    <LinkBlockField><Value inputRef={input => { if (input) input.value = p.lessonDescriptor; }} onBlur={e => subfieldChanged('links', i, 'lessonDescriptor', e.target.value)} /></LinkBlockField>
                    <LinkBlockField><Value inputRef={input => { if (input) input.value = p.target; }} onBlur={e => subfieldChanged('links', i, 'target', e.target.value)} /></LinkBlockField>
                    <LinkBlockField>{ field.parts.links.length > 1 && <Delete onClick={e => deleteRow(e, 'links', i, p)} /> }</LinkBlockField>
                </LinkBlockRow>
            )}
            <AddBlock onClick={e => addRow(e, 'links')}>+</AddBlock>
        </LinkBlockWrapper>
    );
};


